// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"clinical-portal-3__navigation__sidebar","list":"clinical-portal-3__navigation__list","moreLinks":"clinical-portal-3__navigation__moreLinks"};